export const EXTENSIONS = [".doc", ".docx", ".pdf", ".epub"];
export const MAX_FILE_SIZE = 4e+6; // Maximum file size (in bytes)
export const MIN_BALANCE = 50;
